module.exports = __webpack_public_path__ + "static/media/StatsIcon01.c5ab29b0.svg";